import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { getItemById } from '../lib/util';
// import './BreadcrumbCatalog.css';

const BreadcrumbCatalog = (props) => {
  const { location, categories } = props;
  let renderBreadcrumb = [];
  if (categories.length > 0) {
    renderBreadcrumb = location.pathname
      .split('/')
      .slice(2)
      .map((elem, idx, arr) => {
        const category = getItemById({
          id: elem * 1,
          array: categories,
          key: 'category_ID',
        });
        return (
          <li key={`breadcrumb-${idx}`} className={idx === arr.length - 1 ? 'is-active' : ''}>
            <Link
              to={location.pathname
                .split('/')
                .slice(0, idx + 3)
                .join('/')}
              aria-current="page"
            >
              {category.title}
            </Link>
          </li>
        );
      });
  }
  return (
    <div className="level breadcrumb-wrapper">
      <div className="level-left">
        <div className="level-item">
          <nav className="breadcrumb" aria-label="breadcrumbs">
            <ul>
              <li>
                <Link to="/">首頁</Link>
              </li>
              {renderBreadcrumb}
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};

BreadcrumbCatalog.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  categories: PropTypes.arrayOf(PropTypes.object).isRequired,
};

BreadcrumbCatalog.defaultProps = {
  location: {
    pathname: '/',
  },
};

export default BreadcrumbCatalog;



// WEBPACK FOOTER //
// ./src/components/BreadcrumbCatalog.js